module.exports = __webpack_public_path__ + "media/customizations/icpnaples/logo-970080d5d7d2a4a9eef0f4b7b85d41f8.png";